import React from 'react';
import {
  NextStopCompliancePickupMarker,
  NextStopComplianceStopMarker
} from '../../../../../../mapComponents/Markers';
import RestBreakIcon from '@material-ui/icons/AirlineSeatReclineExtra';
import LocalGasStationOutlinedIcon from '@material-ui/icons/LocalGasStationOutlined';
import RestaurantOutlinedIcon from '@material-ui/icons/RestaurantOutlined';
import { withTheme } from '@material-ui/core';
import { STOP_TYPE } from '../../../constants';

const StopIcon = ({ stop, active, theme, classes }) => {
  const colorProps = active
    ? {
        color: theme.HeaderSelectedText,
        textColor: theme.StopIconColor,
        strokeColor: theme.HeaderSelectedText
      }
    : {
        textColor: theme.HeaderSelectedText,
        color: theme.StopIconColor,
        strokeColor: theme.HeaderSelectedText
      };

  const IconType = () => {
    switch (stop.stopType) {
      case STOP_TYPE.Delivery:
      case STOP_TYPE.TrailerDrop:
        return (
          <NextStopComplianceStopMarker
            stopSequence={stop.routeMaxUIStopSequence}
            {...colorProps}
            size={25}
          />
        );
      case 'LunchBreak':
        return <RestaurantOutlinedIcon className={classes.iconStyle} />;
      case 'FuelBreak':
        return <LocalGasStationOutlinedIcon className={classes.iconStyle} />;
      case 'RestBreak':
        return <RestBreakIcon className={classes.iconStyle} />;
      default:
        return (
          <NextStopCompliancePickupMarker
            stopSequence={stop.routeMaxUIStopSequence}
            {...colorProps}
            size={25}
          />
        );
    }
  };

  return <span>{IconType()}</span>;
};

export default withTheme()(StopIcon);
